import React, {FC} from "react";
import {NavLink} from "react-router-dom";
import "./NavigationComponent.css";
import LoginComponent from "./LoginComponent";
import {toast} from "react-hot-toast";
import GatewayService from "../service/GatewayService";

const NavigationComponent:FC = ()=>{
    function kill() {
        toast("api in progress")
        GatewayService.kill().then(resp => {
            toast(JSON.stringify(resp), {duration : 100000})
            setTimeout(()=>{
                toast("ensure you hit https://bff.tushartrades.com/options/orders/true after restart")
            },1000)
        });
    }

    return (
        <>
            <nav className="main-navbar">
                <div className="nav-left">
                    <NavLink to="/" className="nav-link">My App</NavLink>
                    <NavLink to="/option" className="nav-link">All options</NavLink>
                    <NavLink to="/orders" className="nav-link">Placed Orders</NavLink>
                    <div className="dropdown">
                        <span className="nav-link">opportunities</span>
                        <div className="dropdown-content">
                            <NavLink to="/missed" className="nav-link">Missed Opportunity</NavLink>
                            <NavLink to="/square-off" className="nav-link">Sq Off</NavLink>
                            <NavLink to="/option/type/opp" className="nav-link">opp</NavLink>
                        </div>
                    </div>
                    <NavLink to="/sgb" className="nav-link">SGB</NavLink>
                    <NavLink to="/bonds" className="nav-link">Bonds</NavLink>
                    <div className="dropdown">
                        <span className="nav-link">Report</span>
                        <div className="dropdown-content">
                            <NavLink to="/report/client" className="nav-link">Client Reports</NavLink>
                            <NavLink to="/contract/note" className="nav-link">Contract Notes</NavLink>
                            <NavLink to="/report/position" className="nav-link">Carry Forward</NavLink>
                            <NavLink to="/report/closing" className="nav-link">Closing Prices</NavLink>
                            <NavLink to="/report/mcx-devolvement" className="nav-link">MCX Devolvement</NavLink>
                        </div>
                    </div>
                    <NavLink to="/equity" className="nav-link">Live Closing Prices</NavLink>
                    <div className="dropdown">
                        <span className="nav-link">positions</span>
                        <div className="dropdown-content">
                            <NavLink to="/option/type/positions" className="nav-link">positions</NavLink>
                            <NavLink to="/option/type/deep-analyse" className="nav-link">deep analyse</NavLink>
                            <NavLink to="/option/type/squeeze" className="nav-link">squeeze</NavLink>
                            <NavLink to="/trade-analyzer" className="nav-link">Trade Analyzer</NavLink>
                            <NavLink to="/today-trades" className="nav-link">Today's Trades</NavLink>
                        </div>
                    </div>
                </div>
                <div className="nav-right">
                    <button className="nav-restart-btn" onClick={kill}>Restart Apps</button>
                </div>
            </nav>
        </>
    )
}

export default NavigationComponent
